import { useQuery } from "@tanstack/react-query";

import {
    ModelsCampaignV2ModelList,
    ModelsGetCampaignV2ListRequest,
    PostApiInternalCampaignV2List200,
} from "@/schemas";
import { postApiInternalCampaignV2List } from "@/shared/api/campaign-v2";
import { createQueryOptions } from "@/shared/lib/api";

export const useGetAllCampaigns = (body?: ModelsGetCampaignV2ListRequest, enabled = true) => {
    const preparedBody = { ...(body || {}) };

    const query = useQuery(
        createQueryOptions<PostApiInternalCampaignV2List200, ModelsCampaignV2ModelList>({
            queryKey: ["getAllCampaigns", preparedBody],
            queryFn: () => postApiInternalCampaignV2List(preparedBody),
            preset: "list",
            enabled,
            select: (response) => response.data || {},
        }),
    );

    return {
        ...query,
        data: query.data?.campaigns,
        pagination: query.data?.pagination,
    };
};
